import React from 'react'
import { useTranslation } from 'react-i18next'

import { Col, Row } from 'antd'

import ResultDialog from 'common/components/feedback/result'

import Modal from '../../../../../../common/components/feedback/Modal'
import Icon from '../../../../../../common/components/general/Icon'

const FinishDesignSuccessModal = () => {
  const { t: translate } = useTranslation()

  return (
    <>
      <Modal visible footer={false} closable={false} width={400}>
        <ResultDialog
          status="success"
          className="p-0"
          subTitle={translate('admin-dashboard.benefit-details.success-modal.subTitle')}
          title={translate('admin-dashboard.benefit-details.success-modal.title')}
          extra={[
            <Row gutter={8} className="justify_center">
              <Col>
                <Icon className="fas fa-sync color-green-6" />
              </Col>
              <Col>
                <p>{translate('admin-dashboard.benefit-details.success-modal.extra-text')}</p>
              </Col>
            </Row>,
          ]}
        />
      </Modal>
    </>
  )
}
export default FinishDesignSuccessModal
